var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle32A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M37.998 14h14l.725 7.251A2.5 2.5 0 0 1 50.236 24H25.76a2.5 2.5 0 0 1-2.488-2.749L23.998 14h14Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M52.998 14h-30"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20 29.5a2.5 2.5 0 0 1 2.5-2.5h31a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-31a2.5 2.5 0 0 1-2.5-2.5v-15ZM5.998 42V32l8.274-.752a2.5 2.5 0 0 1 2.726 2.49v6.524a2.5 2.5 0 0 1-2.726 2.49L5.998 42Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m7.998 43-.445-.223a2.813 2.813 0 0 1-1.555-2.515v-6.524c0-1.065.602-2.039 1.555-2.515L7.998 31"
})));
SvgRectangle32A.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle32A);
export default ForwardRef;